module.exports = __webpack_public_path__ + "img/guozai_02.6cecc758.jpg";